import type { ReactNode } from "react";

import { StyleProvider } from "@ant-design/cssinjs";
import { App, ConfigProvider } from "antd";

import { useBranding } from "@/features/branding/useBranding";

import { buildAntdTheme } from "@/shared/lib/antdTheme";
import {
  MODAL_FORM_BODY_STYLES,
  MODAL_FORM_CLASS_NAMES,
} from "@/shared/ui/modalFormStyles";

interface Props {
  children: ReactNode;
}

/** ConfigProvider seeded from the tenant's brand hex. */
export function AntdThemeProvider({ children }: Props) {
  const { primaryColor } = useBranding();
  return (
    <StyleProvider layer>
      <ConfigProvider
        theme={buildAntdTheme(primaryColor)}
        modal={{
          centered: true,
          styles: MODAL_FORM_BODY_STYLES,
          classNames: MODAL_FORM_CLASS_NAMES,
        }}
      >
        {/* App enables Modal.confirm / message / notification hooks (Ant Design 5). */}
        <App>{children}</App>
      </ConfigProvider>
    </StyleProvider>
  );
}
